import { Undo2, Redo2, Eye } from 'lucide-react';
import { Button } from '../ui/Button';
import { useTranslation } from '../../i18n';
import styles from './ImageEditor.module.css';

interface ImageEditorHeaderProps {
  canUndo: boolean;
  canRedo: boolean;
  isSaving: boolean;
  onUndo: () => void;
  onRedo: () => void;
  onCompareDown: () => void;
  onCompareUp: () => void;
  onCancel: () => void;
  onApply: () => void;
}

export function ImageEditorHeader({
  canUndo,
  canRedo,
  isSaving,
  onUndo,
  onRedo,
  onCompareDown,
  onCompareUp,
  onCancel,
  onApply,
}: ImageEditorHeaderProps) {
  const { t } = useTranslation();

  return (
    <header className={styles.header}>
      <span className={styles.title}>{t('imageEditor.title')}</span>

      <div className={styles.headerActions}>
        <button
          type="button"
          className={styles.headerBtn}
          onClick={onUndo}
          disabled={!canUndo}
          title={t('imageEditor.undo')}
        >
          <Undo2 size={16} />
        </button>
        <button
          type="button"
          className={styles.headerBtn}
          onClick={onRedo}
          disabled={!canRedo}
          title={t('imageEditor.redo')}
        >
          <Redo2 size={16} />
        </button>

        <span className={styles.headerSep} />

        <button
          type="button"
          className={styles.headerBtn}
          onPointerDown={onCompareDown}
          onPointerUp={onCompareUp}
          onPointerLeave={onCompareUp}
          title={t('imageEditor.compare')}
        >
          <Eye size={16} />
          <span className={styles.compareLbl}>{t('imageEditor.compare')}</span>
        </button>
      </div>

      <div className={styles.headerEnd}>
        <Button variant="secondary" onClick={onCancel} disabled={isSaving}>
          {t('imageEditor.cancel')}
        </Button>
        <Button onClick={onApply} disabled={isSaving}>
          {isSaving ? t('imageEditor.saving') : t('imageEditor.applyAndUpload')}
        </Button>
      </div>
    </header>
  );
}
